import { NextPageContext } from 'next';
import type { Store } from '@reduxjs/toolkit';
import type { Action, ThunkDispatch } from '@reduxjs/toolkit';
import type { RootState } from '@reducers/index';
import {
  getClientsideEnvironmentId,
  readEnvironmentIdFromHeaders,
} from '@sbt-web/utils';
import { updateEnvironmentId } from '@reducers/env';
import { getErrorMessage } from '@tools/errorHelpers';

export const setEnviromentId = (
  req: NextPageContext['req'] | undefined,
  store: Store<RootState>,
  dispatch: ThunkDispatch<RootState, unknown, Action<string>>
): string | null => {
  let environmentId: string | null = null;

  if (__SERVER__) {
    try {
      if (req != null) {
        environmentId = readEnvironmentIdFromHeaders(req);
        if (environmentId) {
          store.dispatch(updateEnvironmentId(environmentId));
        }
      }
    } catch (error) {
      console.error(
        'Could not set the Environment ID on the serverside,',
        getErrorMessage(error)
      );
    }
  } else {
    try {
      environmentId = getClientsideEnvironmentId();
      if (environmentId) {
        dispatch(updateEnvironmentId(environmentId));
      }
    } catch (error) {
      console.error(
        'Could not set the Environment ID on the clientside,',
        getErrorMessage(error)
      );
    }
  }

  return environmentId;
};
